// useBootstrap.js
import BootstrapNative from 'bootstrap.native/dist/bootstrap-native-v4';
import BootstrapDialog from '../../theme/js/bootstrap-dialog.min.js'

export function useBootstrap() {
    const openModal = (modalId) => {
        const modal = new BootstrapNative.Modal(document.getElementById(modalId));
        modal.show()
    }

    const openVideoModal = (code) => {
        const modal = new BootstrapNative.Modal(document.getElementById('videoModal'));
        modal.setContent('<div class="js-video youtube widescreen"><iframe width="729" height="500" src="//www.youtube.com/embed/' + code + '?hd=1" allowfullscreen></iframe></div>')
        modal.show()
    }

    const showModal = (message, buttonLabel) => {
        const dialog = BootstrapDialog.show({
            type: BootstrapDialog.TYPE_LIGHT,
            closable: false,
            message: message,
            buttons: [{
                cssClass: 'btn-dark',
                label: buttonLabel,
                action: function (dialog) {
                    dialog.close()
                }
            }]
        })
        dialog.getModalHeader().hide()
    }

    return {
        openModal,
        openVideoModal,
        showModal,
    }
}
